import { Utilities } from 'core/domains';

import type { ShippingModel } from 'core';

export const initialState: ShippingModel = {
  data: {
    availables: [],
    default: {
      code: 0,
      delivery: {
        address: '',
        distributionCenterCode: 0,
        isWithdrawalCenter: false,
      },
    },
  },
  toggleActive: false,
  message: '',
  shippingModelSearch: '',
  status: Utilities.STATUS.IDLE,
  updatedAt: 0,
};
